import { Component, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { getUserUser } from '../../reducers/index';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnDestroy {

  fulfillFlightsPermission = false;
  publishedFlightsPermission = false;
  private userSubscription: Subscription;

  constructor(private store: Store<any>, private router: Router) {
    this.userSubscription = this.store.pipe(select(getUserUser), take(1)).subscribe(user => {
      this.fulfillFlightsPermission = user.viewPermissions.fulfillFlights;
      this.publishedFlightsPermission = user.viewPermissions.publishedFlights;
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
}
